import { serverApi } from "../api";


export const getPendientes = async () => {

    // const server_url=  process.env.REACT_APP_PRODUCCION;  

    const codigoEntidad = localStorage.getItem('codigoEntidad') || null;
    const codigoUbicacion = localStorage.getItem('codigoUbicacion') || null;

    if (codigoEntidad === null) return [];
    if (codigoUbicacion === null) return [];


    try {

        const resp = await serverApi.get(`/tickets/pendientes/${codigoEntidad}/${codigoUbicacion}`);
        console.log(resp);


        return (resp.data.pendientes);

    } catch (error) {
        console.error("Error al obtener ubicaciones", error);
    }


    // const resp = await fetch(`${server_url}/pendientes/${codigoEntidad}`);
    // const data = await resp.json();

    // return(data.pendientes);

}